<script lang="ts">
	//Stores
	import { edit } from 'src/stores/ui/edit_lists';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { temp_schemes } from 'src/stores/lists/scenes-derived';
	//Design System components
	import { DashControlWidget } from '@Shelly/shelly-design-system/index';
	//Components
	import ControlsThermostat from 'src/components/Lists/Thermostats/ControlsThermostat.svelte';
	import { generateThermostatIcon } from 'src/components/Lists/list-helpers';
	import { format } from 'svelte-i18n';
	import { hasMissingThermostatDevice } from 'src/components/Scenes/helpers/has_missing_thermostat_device';
	import type { DashDeviceWidgetPropsTypes } from '@Shelly/shelly-design-system';

	export let thermostatWidget;

	let additionalText: DashDeviceWidgetPropsTypes['additionalText'] = {
		value: '',
	};

	$: thermostat = $temp_schemes[thermostatWidget?.id];

	$: value = !thermostat ? thermostatWidget?.id : thermostat?._meta.name;

	$: hasMissingDevice = hasMissingThermostatDevice(thermostat?.id);

	$: icon = !thermostat
		? 'fat fa-triangle-exclamation text-color-warning'
		: generateThermostatIcon(thermostat, 'fat');

	$: additionalText = !thermostat
		? {
				value: $format('label_missing_thermostat', {
					default: 'Missing Thermostat',
				}),
				type: 'warning',
			}
		: {
				value: hasMissingDevice
					? $format('label_missing_device', {
							default: 'Missing Device',
						})
					: '',
				icon: hasMissingDevice ? 'fa-light fa-triangle-exclamation' : '',
				type: hasMissingDevice ? 'warning' : 'muted',
			};
</script>

<DashControlWidget
	aria-label="Dash Control Thermostat Widget"
	class="cursor-pointer"
	avatar={{
		icon: icon,
	}}
	{additionalText}
	{value}
	selected={thermostatWidget?.id === $sidePanelStateCombined?.id}
	hideSlotRight={!thermostat || $edit}
	on:click
>
	<ControlsThermostat dashControlWidget={true} slot="right" item={thermostatWidget} />
</DashControlWidget>
